import type { FaireProductEntity } from "../../entity_types/product";

export const p_8m6us3d68s: FaireProductEntity = {
  token: "p_8m6us3d68s",
  type: "product",
  name: "Elegant Sleeveless Dress with Delicate Trim",
  brandToken: "b_hrmradn4yd",
  brandName: "EmberLoom",
  imageUrl:
    "https://cdn.faire.com/fastly/af085135b5810da980cb2e828969206429298c6d73fe6934a560f1ae5a335c98.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/18723985a3f3c19e6ffe8008d5d7784a80cc226c29cdc229cf5d5e259d01f4a2.jpeg",
    "https://cdn.faire.com/fastly/23ec1206f39a53c743d66a8950c46827b9556d6c7b55f1fab38333cce6fb9092.jpeg",
    "https://cdn.faire.com/fastly/2c930586726908683a8dd68e7e01dad0c3a8bdabcb49d73194ec2ff02708009e.jpeg",
    "https://cdn.faire.com/fastly/4feb794599d41f000be5ce2d8c51c077b2c2b2f23c99bd50ebf41c9996a4cd4f.jpeg",
    "https://cdn.faire.com/fastly/dc9300b01f358acedbb28ec2c6a0e24390d4ed26bfdebb02d50de84f87853d88.jpeg",
  ],
  priceDollars: 21.68,
  description:
    "This elegant sleeveless dress features a refined silhouette. The subtle trim adds a touch of sophistication to the design. Perfect for formal occasions or chic everyday wear.",
  tags: [],
  msrpDollars: 43.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:16.974Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
